import React from "react";

const Bento = () => {
  return (
    <>
      <div className="grid">
        <div className="grid-1 border-r">
          <h3>Je natuurlijke charme behouden met een minimale aanpak.</h3>
        </div>
        <div className="grid-2 border-r"></div>
        <div className="grid-3 border-r"></div>
        <div className="grid-mobile">
          <div className="grid-4 border-r">
            <img src="/images/peelers.svg" alt="Peelers icon" />
            <a href="/behandelingen/omega-hydro-ii-peeling">PEELING</a>
          </div>
          <div className="grid-5 border-r">
            <img src="/images/fillers.svg" alt="Fillers icon" />
            <a href="/behandelingen">FILLERS</a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Bento;
